// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout'
import {roterPre} from '@/settings'

const orderRouter =
    {
        path: `${roterPre}/recovery`,
        name: 'appraisal',
        meta: {
            icon: 'dashboard',
            title: '回收'
        },
        alwaysShow: true,
        component: Layout,
        redirect: `${roterPre}/recovery`,
        children: [
            {
                path: 'category',
                name: 'recoveryCategory',
                meta: {
                    title: '分类管理',
                    noCache: true
                },
                component: () => import('@/views/recovery/category/index')
            }, {
                path: 'category/add/:id?/:edit?',
                component: () => import('@/views/recovery/category/info'),
                name: 'addCate',
                meta: {title: '分类添加', noCache: true, activeMenu: `${roterPre}/recovery/category`},
                hidden: true
            },
            {
                path: 'problem',
                name: 'recoveryProblem',
                meta: {
                    title: '问题管理',
                    noCache: true
                },
                component: () => import('@/views/recovery/problem/index')
            },
            {
                path: 'order',
                name: 'recoveryOrder',
                meta: {
                    title: '订单管理',
                    noCache: true
                },
                component: () => import('@/views/recovery/order/index')
            },
            {
                path: 'stock',
                name: 'recoveryStock',
                meta: {
                    title: '回收记录',
                    noCache: true
                },
                component: () => import('@/views/recovery/stock/index')
            },
            {
                path: 'historyPrice',
                name: 'historyPrice',
                meta: {
                    title: '历史价修改',
                    noCache: true
                },
                component: () => import('@/views/recovery/historyPrice/index')
            },
            {
                path: 'officialOrder',
                name: 'officialOrder',
                meta: {
                    title: '官方回收订单',
                    noCache: true
                },
                component: () => import('@/views/recovery/officialOrder/index')
            }, {
                path: 'warehousing',
                name: 'warehousing',
                meta: {
                    title: '回收入库',
                    noCache: true
                },
                component: () => import('@/views/recovery/stock/warehousing.vue')
            },
            {
                path: 'goodsOut',
                name: 'goodsOut',
                meta: {
                    title: '商品出库',
                    noCache: true
                },
                component: () => import('@/views/recovery/order/goodsOut.vue')
            },
            {
                path: 'warehouseVideo',
                name: 'warehouseVideo',
                meta: {
                    title: '回收入库视频',
                    noCache: true
                },
                component: () => import('@/views/recovery/stock/warehouseVideo.vue')
            },
          {
            path: 'stashList',
            name: 'stashList',
            meta: {
              title: '出库列表',
              noCache: true
            },
            component: () => import('@/views/recovery/stashManage/stashList')
          },
          {
            path: 'stashManage',
            name: 'stashManage',
            meta: {
              title: '总库存',
              noCache: true
            },
            component:()=> import('@/views/recovery/stashManage/index')
          },
          {
            path: 'keepClient',
            name: 'keepClient',
            meta: {
              title: '常联系客户',
              noCache: true
            },
            component:()=> import('@/views/recovery/stashManage/keepClient')
          },
          {
            path: 'warehous/add/list',
            name: 'warehousAddList',
            meta: {
              title: '手动库存记录',
              noCache: true
            },
            component: () => import('@/views/recovery/warehous/index')
          },
          {
            path: 'order/sett/list',
            name: 'orderSettList',
            meta: {
              title: '结算记录',
              noCache: true
            },
            component: () => import('@/views/recovery/sett/index')
          },
          {

            path: 'dayStock',
            name: 'dayStock',
            meta: {
              title: '每日库存',
              noCache: true
            },
            component: () => import('@/views/recovery/stashManage/dayStock')
          },
          {
            path: 'wornList',
            name: 'wornList',
            meta: {
              title: '原因列表',
              noCache: true
            },
            component: () => import('@/views/recovery/stashManage/wornList')
          }
        ]
    }

export default orderRouter
